<template>
  <MerchantGroupForm />
</template>

<script setup lang="ts"></script>
